export default function MembershipBenefits() {
  const benefits = [
    {
      icon: 'ri-vip-crown-line',
      title: 'Priority Access',
      description: 'Skip the wait with guaranteed same-day or next-day appointments.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Personalized Care',
      description: 'Dedicated wellness team tracks your progress and customizes treatments.',
    },
    {
      icon: 'ri-gift-line',
      title: 'Exclusive Perks',
      description: 'Member-only events, workshops, and seasonal wellness retreats.',
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Concierge Service',
      description: 'Elite and Platinum members enjoy white-glove booking and at-home options.',
    },
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-bone">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-charcoal mb-6 tracking-wide">
            Member Benefits
          </h2>
          <p className="text-greige text-lg font-light leading-relaxed max-w-2xl mx-auto">
            Experience wellness redefined with privileges designed for discerning individuals who value their health and time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="text-center group"
            >
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-full bg-gold/10 group-hover:bg-gold transition-all duration-300">
                <i className={`${benefit.icon} text-3xl text-gold group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-normal text-charcoal mb-3 tracking-wide">
                {benefit.title}
              </h3>
              <p className="text-greige text-sm font-light leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}